<script>
    import UAParser from "ua-parser-js";
    let parser = new UAParser();
    let os = parser.getOS();

    import { getContext, onMount } from "svelte";
    const { close } = getContext('simple-modal');

  
    // Icons
    import DirectionsIcon from "./IconDirections.svelte"
    import IconWalk from "./IconWalk.svelte"
    import IconCar from "./IconCar.svelte"
    import Icon360 from "./Icon360.svelte"
    
    // Exports
    export let image;
    export let title;
    export let content;
    export let linkedscenes = [];
    export let driveLocation;
    export let walkLocation;
    
    if(content){
        content = parseContent(content);
    }
  
    let walkUrl;
    if(walkLocation){
      if( os.name === "iOS"){
        walkUrl = `http://maps.apple.com/?daddr=${walkLocation.lat},${walkLocation.lng}&t=s`;
      } else {
        walkUrl = `https://www.google.com/maps/dir//${walkLocation.lat},${walkLocation.lng}/@${walkLocation.lat},${walkLocation.lng},12z/data=!3m1!4b1!4m2!4m1!3e2`;
      }
    }
  
    let driveUrl;
    if(driveLocation){
      if( os.name === "iOS"){
        driveUrl = `http://maps.apple.com/?daddr=${driveLocation.lat},${driveLocation.lng}&t=s`;
      } else {
        driveUrl = `https://www.google.com/maps/dir//${driveLocation.lat},${driveLocation.lng}/@${driveLocation.lat},${driveLocation.lng},12z/data=!4m2!4m1!3e0`;
      }
    }
  
    if(linkedscenes){
      linkedscenes.forEach(s => {
        s.url = `https://covecreekproductions.com/tours/davidsondavie/?startscene=${s.scene}`;
      });
    }
  
    function parseContent(content){
        return content
            .replaceAll('[', '<')
            .replaceAll(']', '>')
    }

    function loadScene(sceneName){
        window.CC.krpano.call("loadscene("+sceneName+",null,get(skin_settings.loadscene_flags),get(skin_settings.loadscene_blend));");
        if(window.CC.switchView){
            window.CC.switchView();
        }
        close();
    }
  </script>
  
  <style>
  .popup {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  font-family: 'Raleway', sans-serif;
  }
  
  .column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  height: 100%;
  }
  
  .image {
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  }
  
  .content {
  justify-content: center;
  }
  
  .content-inner {
  padding: 1rem;
  overflow-y: scroll;
  padding-bottom: 0;
  max-height: 400px;
  }
    
  :global(.popup .content-inner a){
    color: #fff;
    font-weight: 500;
  }
  
  ::-webkit-scrollbar {
  width: 6px;
  }
  ::-webkit-scrollbar-thumb {
  background: #fff;
  }
  
  ::-webkit-scrollbar-thumb:hover{
    background: #ddd;
  }
  
  a {
  color: #fff;
  text-decoration: underline;
  }
  
  a:hover {
  font-weight: bold;
  }
  
  .actions {
    padding: 1rem;
    padding-top: 0;
  }
  
  .title {
    font-size: 2rem;
    font-weight: 900;
    margin: 0;
    margin-bottom: 1em;
  }
  
  .button {
  background: #000;
  padding: 0.75rem;
  color: #fff;
  border-radius: 5px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  }
  
  .button:hover {
    background: #333;
  }
  
  .button span {
  margin-left: 0.5em;
  }
  
  
  .link {
  display: flex;
  align-items: center;
  cursor: pointer;
  }
  
  .icon-text {
  display: flex;
  align-items: center;
  }
  
  .icon-text span {
  margin: 0 0.5em;
  font-weight: 500;
  }
  
  .icon-container {
  width: 1.5em;
  height: 1.5em;
  text-align: center;
  }
  
  .linkedscenes {
    padding: 0 0 1em 0;
  }
  
  .linkedscenes h3 {
    margin-bottom: 0.25em;
  }
  
  .linkedscenes ul {
    margin-top: 0;
  }
  </style>
  
  <div class="popup">
  <!-- {#if image}
  <div class="image column" style={`background-image: url(${image});`}></div>
  {/if} -->
  
  <div class="content column">
    <div class="content-inner">
        <h2 class="title">{title}</h2>
        {#if content}{@html content}{/if}
  
        {#if linkedscenes.length > 1}
        <div class="linkedscenes">
          <h3 class="icon-text">
            <div class="icon-container">
              <Icon360 fill="#fff" size={'1.5em'}/>
            </div>
            <span>Open in Virtual Tour:</span>
          </h3>
  
          <ul>
            {#each linkedscenes as ls}
              <li>
                <a class="link" on:click={()=>{ loadScene(`${ls.scene}`) }}>
                  {ls.title}
                </a> 
              </li>
            {/each}
          </ul>
        </div>
        {/if}
  
    </div>
    <div class="actions">
      <!-- Walking Link -->
      {#if walkLocation}
      <a class="link icon-text" href={walkUrl} target={'_blank'}>
        <div class="icon-container"><IconWalk size={'0.65em'} fill="#fff"/></div>
        <span>Walk to this location</span>
      </a>
      {/if}
      <!-- Driving Link -->
      {#if driveLocation}
      <a class="link icon-text" href={driveUrl} target={'_blank'}>
        <div class="icon-container"><IconCar size={'1.5em'} fill="#fff"/></div>
        <span>Drive to this location</span>
      </a>
      {/if}
      <!-- 360 Pano Link -->
      {#if linkedscenes.length == 1}
        <a class="link icon-text" on:click={()=>{ loadScene(`${linkedscenes[0].scene}`) }}>
          <div class="icon-container"><Icon360 fill="#fff" size={'1.5em'}/></div>
          <span>Open in Virtual Tour</span>
        </a>
      {/if}
    </div>
  </div>
  </div>
  
  